export type EventBusCallback<T> = (params: T) => void;

class EventBusGenerator {
  private events: Record<string, EventBusCallback<any>[]> = {};

  /**
   * Add Event Listener to EvenBus
   *
   * @param {string} eventName
   * @param {EventBusCallback} callback
   */
  public on<T>(eventName: string, callback: EventBusCallback<T>) {
    if (this.events[eventName]) {
      this.events[eventName].push(callback);
    } else {
      this.events[eventName] = [callback];
    }
  }

  /**
   * Remove Event Listener to EvenBus
   *
   * @param {string} eventName
   * @param {EventBusCallback} callback
   */
  public off<T>(eventName: string, callback: EventBusCallback<T>) {
    if (this.events[eventName]) {
      this.events[eventName] = this.events[eventName].filter(cb => cb !== callback);
    } else {
      this.events[eventName] = [];
    }
  }

  /**
   * Dispatch Event
   *
   * @param {string} eventName
   * @param {T | undefined} params
   */
  public emit<T>(eventName: string, params?: T) {
    if (this.events[eventName]) {
      this.events[eventName].forEach(callback => {
        callback(params);
      });
    }
  }

  /**
   * Add Event Listener to EvenBus but only run one time
   *
   * @param {string} eventName
   * @param {EventBusCallback} callback
   */
  public once<T>(eventName: string, callback: EventBusCallback<T>) {
    const handler = (params: T) => {
      callback(params);
      this.off(eventName, callback);
    };

    if (this.events[eventName]) {
      this.events[eventName].push(handler);
    } else {
      this.events[eventName] = [handler];
    }
  }
}

const EventBusUtils = new EventBusGenerator();

export default EventBusUtils;
